import { useState } from 'react';
import { getTimeWithTimeZone } from 'utility/general';
import { statusKeyToDisplay, statusLookup } from 'utility/lookup';

const useStatusHistoryData = ({ statusHistory }) => {
    const getStatusLookup = () => {
        const result = {};

        statusLookup.forEach((item) => {
            return (result[item.key] = item.statusDisplay);
        });

        return result;
    };

    const [statusSortLookup] = useState(getStatusLookup);

    const rawColumn = [
        {
            field: 'createDtm',
            headerName: 'Date',
            width: 160,
            valueGetter: (params) => {
                return getTimeWithTimeZone(params.value).format('YYYY-MM-DD HH:mm:ss');
            },
        },
        { field: 'documentType', headerName: 'Document Type', width: 200 },
        { field: 'fullName', headerName: 'User', width: 170 },
        {
            field: 'fromStatus',
            headerName: 'From',
            width: 100,
            sortLookup: statusSortLookup,
            valueGetter: (params) => {
                return statusKeyToDisplay(params.value);
            },
        },
        {
            field: 'toStatus',
            headerName: 'To',
            width: 100,
            sortLookup: statusSortLookup,
            valueGetter: (params) => {
                return statusKeyToDisplay(params.value);
            },
        },
        {
            field: 'originalSubNo',
            headerName: 'Original Submission No.',
            width: 170,
            valueGetter: (params) => {
                return params.value ?? '-';
            },
        },
    ];

    const getRowsWithId = () => {
        return (
            statusHistory?.map((item, index) => {
                item.id = index;
                return item;
            }) ?? []
        );
    };

    return { columns: rawColumn, rawColumn: rawColumn, rows: getRowsWithId() };
};

export default useStatusHistoryData;
